/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export interface InquirySellerAgencyBranchResponseDto {
  /** @nullable */
  name: string | null;
  /** @nullable */
  businessName: string | null;
  /** @nullable */
  street: string | null;
  /** @nullable */
  streetNumber: string | null;
  /** @nullable */
  city: string | null;
  /** @nullable */
  zipCode: string | null;
  /** @nullable */
  country: string | null;
}
